import { render, staticRenderFns } from "./NoteSideBar.vue?vue&type=template&id=e14b1d58&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/components/NoteSideBar.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/components/NoteSideBar.js?vue&type=script&lang=js&"
import style0 from "./NoteSideBar.vue?vue&type=style&index=0&id=e14b1d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14b1d58",
  null
  
)

export default component.exports